import styled from "styled-components";
import {HomepageHeaderArenaTileDefaultBox} from "./home-page-header-arena-tile.default.box";

export const HomepageHeaderArenaTileCasino777Box = styled(HomepageHeaderArenaTileDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    max-width: min(${({totalItemsCount}) => 100 / totalItemsCount}%, 220px);
  }

`;
